import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import CombinedSelect from '../combined';
import { Button } from '@ynap/button';
import { Dots, Tick, Cross } from '@ynap/animations';
import { Notification } from '@ynap/notification';
const bem = new BEMHelper('AsyncSelect');

class AsyncSelect extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            animationStep: 0,
            notification: null,
            mobilePrompt: this.props.mobilePrompt,
            wishlistSelected: null,
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.triggerOnClick = this.triggerOnClick.bind(this);
        this.handleRemoveError = this.handleRemoveError.bind(this);
    }

    timerIds = [];

    componentDidUpdate(prevProps) {
        const { asyncState, errorNotificationTimer = true } = this.props;
        const { loading, error, secondaryAction } = asyncState;

        if (!loading) {
            if (!error && this.state.animationStep === 1) {
                this.setState({ animationStep: 2 });
                const primaryTimerId = setTimeout(() => {
                    if (secondaryAction) {
                        this.setState({ animationStep: 3 });
                        const secondaryTimerId = setTimeout(() => {
                            this.setState({ animationStep: 0 });
                        }, secondaryAction.timeout || 2600); // animation secondary button step time
                        this.timerIds.push(secondaryTimerId);
                    } else {
                        this.setState({ animationStep: 0 });
                    }
                }, 2000); // tick animation step time
                this.timerIds.push(primaryTimerId);
            }
            if (error && !prevProps.asyncState.error) {
                //dont clear notification if errorNotificationTimer is set to false
                const resetNotification = errorNotificationTimer ? { notification: null } : null;
                const errorTimerId = setTimeout(() => {
                    this.setState({ ...resetNotification, animationStep: 0 });
                }, 2000); // error step time
                this.timerIds.push(errorTimerId);

                this.setState({
                    notification: asyncState.error,
                    animationStep: 4,
                });
            }
        }
        if (error || this.state.notification) {
            document.addEventListener('click', this.handleRemoveError);
        }
    }

    componentWillUnmount() {
        while (this.timerIds.length) clearTimeout(this.timerIds.pop());
    }

    handleRemoveError() {
        if (this.errorTimer) {
            clearTimeout(this.errorTimer);
        }
        this.setState({ notification: null, mobilePrompt: null });
        document.removeEventListener('click', this.handleRemoveError);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    triggerOnClick(addToWishlist, skuPartNumber, value, addToWishlistLoading) {
        const { proceedaction = true, notificationmessage, wishlist, urlConfig, locale, messages, setNoSizeNotification, asyncState, optimizely } = this.props;
        const { goToWishlist } = wishlist;
        if (proceedaction) {
            if (this.state.animationStep === 0) {
                addToWishlist(skuPartNumber, value, null, {}, addToWishlistLoading);
                this.setState({ animationStep: 1, notification: null });
                this.setState({ wishlistSelected: value });
                /* istanbul ignore next */
                if (optimizely?.user?.attributes?.clicks_Intelistyle) {
                    optimizely?.track?.('ATW_Intelistyle');
                }
                optimizely?.track?.('add_to_wishlist_clicks');
                /* istanbul ignore next */
                if (optimizely?.user?.attributes?.clicks_Intelistyle) {
                    optimizely.track('ATW_Intelistyle');
                }
                /* istanbul ignore next */
                optimizely?.track?.('addtobag_addtowishlist');
            } else if (this.state.animationStep === 3) {
                goToWishlist(urlConfig, this.state.wishlistSelected, locale);
            }
        } else {
            // If NO_SIZE_SELECTED_ERROR - set hook to update sizeSelect notification
            if (notificationmessage === 'NO_SIZE_SELECTED_ERROR') {
                setNoSizeNotification(messages.notifications.errors({ error: notificationmessage }));
            } else {
                this.setState({ notification: notificationmessage });
            }
            asyncState.trackError();
        }
    }

    render() {
        const {
            notificationPosition,
            arrowPosition,
            wishlist,
            messages = {},
            type,
            asyncState,
            disabled,
            numberOfDisplayWishlist,
            skuPartNumber,
            options,
            openOnMount,
            setNoSizeNotification,
        } = this.props;
        const { addToWishlist, addToWishlistLoading } = wishlist;

        let secondaryButtonContent;
        let primaryActionButton = ['select'];
        let secondaryActionButton = ['secondaryButton'];

        if (this.state.animationStep !== 0) {
            primaryActionButton = [...primaryActionButton, 'animating'];
            secondaryActionButton = [...secondaryActionButton, 'animating'];
        }

        if (this.state.animationStep === 1) {
            secondaryActionButton = [...secondaryActionButton, 'fadeIn'];
            primaryActionButton = ['disabledSelect'];
            secondaryButtonContent = <Dots type={type} />;
        } else if (this.state.animationStep === 2) {
            secondaryActionButton = [...secondaryActionButton, 'fadeIn'];
            primaryActionButton = ['disabledSelect'];
            secondaryButtonContent = <Tick type={type} />;
        } else if (this.state.animationStep === 3 && asyncState.secondaryAction) {
            secondaryButtonContent = asyncState.secondaryAction.message;
            primaryActionButton = ['disabledSelect'];
            secondaryActionButton = [...secondaryActionButton, 'goToWishlistButton', 'fadeIn'];
        } else if (this.state.animationStep === 4) {
            secondaryActionButton = [...secondaryActionButton, 'fadeIn'];
            primaryActionButton = ['disabledSelect'];
            secondaryButtonContent = <Cross type={type} />;
        }

        return (
            <div className={bem('asyncSelectWrapper')} ref={this.setWrapperRef}>
                <CombinedSelect
                    className={bem('wishlistSelect', null, primaryActionButton)}
                    emptyLabel={messages.ctaButtons.addToWishlist()}
                    numOfListElementsDisplayed={numberOfDisplayWishlist ? numberOfDisplayWishlist : undefined}
                    placeholder={addToWishlistLoading ? messages.ctaButtons.addToWishlistLoading() : messages.ctaButtons.addToWishlist()}
                    value=""
                    onChange={(value) => {
                        this.triggerOnClick(addToWishlist, skuPartNumber, value, addToWishlistLoading);
                        this.setState({ mobilePrompt: false });
                    }}
                    options={options}
                    disabled={disabled}
                    openOnMount={openOnMount}
                    setNoSizeNotification={setNoSizeNotification}
                />
                <div className={bem('stackButtons')}>
                    <Button className={bem(null, null, secondaryActionButton)} onClick={this.triggerOnClick} disabled={disabled}>
                        {secondaryButtonContent}
                    </Button>
                </div>
                {this.state.notification && messages.notifications && (
                    <Notification
                        className={bem('notification', notificationPosition)}
                        arrow={arrowPosition}
                        type="error"
                        message={messages.notifications.errors({ error: this.state.notification })}
                    />
                )}
                {this.state.mobilePrompt && (
                    <Notification
                        className={bem('notification', [notificationPosition, this.state.mobilePrompt && 'mobilePrompt'])}
                        arrow={arrowPosition}
                        type="info"
                        message={this.state.mobilePrompt}
                    />
                )}
            </div>
        );
    }
}

AsyncSelect.propTypes = {
    openOnMount: PropTypes.bool,
    mobilePrompt: PropTypes.bool,
    className: PropTypes.string,
    type: PropTypes.string.isRequired,
    proceedaction: PropTypes.bool,
    notificationmessage: PropTypes.string,
    asyncState: PropTypes.shape({
        trackError: PropTypes.func,
        loading: PropTypes.bool,
        primaryAction: PropTypes.shape({
            message: PropTypes.string,
            click: PropTypes.func,
        }),
        secondaryAction: PropTypes.shape({
            message: PropTypes.string,
            click: PropTypes.func,
            timeout: PropTypes.number,
        }),
        error: PropTypes.bool,
    }),
    messages: PropTypes.shape({
        notifications: PropTypes.shape({
            errors: PropTypes.func,
        }),
    }),
    wishlist: PropTypes.shape({
        addToWishlistLoading: PropTypes.bool.isRequired,
        addToWishlist: PropTypes.func.isRequired,
        goToWishlist: PropTypes.func.isRequired,
        wishlists: PropTypes.array,
        wishlistId: PropTypes.string,
    }),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            key: PropTypes.string,
            label: PropTypes.string || PropTypes.node,
            labelNative: PropTypes.string,
        }),
    ),
    skuPartNumber: PropTypes.string.isRequired,
    numberOfDisplayWishlist: PropTypes.number,
    notificationPosition: PropTypes.string,
    arrowPosition: PropTypes.string,
    disabled: PropTypes.bool,
    urlConfig: PropTypes.object,
    locale: PropTypes.string,
    optimizely: PropTypes.object,
    setNoSizeNotification: PropTypes.func,
};

AsyncSelect.defaultProps = {
    notificationPosition: 'top',
    arrowPosition: 'top',
    setNoSizeNotification: () => {},
};

export default AsyncSelect;
